import { render, staticRenderFns } from "./NostockModal.vue?vue&type=template&id=318cf01c&"
import script from "./NostockModal.vue?vue&type=script&lang=js&"
export * from "./NostockModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NostockModal.vue"
export default component.exports